const langKey = {
  urgent_text: 'urgent_text',
  victim_question_title: 'victim_question_title',
  emergency_text: 'emergency_text',
  BUTTON: 'BUTTON',
  complete: 'complete',
  back: 'back',
  continue: 'continue',
  please_fill_out: 'please_fill_out',
  my_name: 'my_name',
  phone_number: 'phone_number',
  email_address: 'email_address',
  issue_box: 'issue_box',
  answer_questions: 'answer_questions',
  work_zip_code: 'work_zip_code',
  specific_worksite: 'specific_worksite',
  gender: 'gender',
  race: 'race',
  approx_age: 'approx_age',
  height: 'height',
  weight: 'weight',
  hair_color: 'hair_color',
  other_details: 'other_details',
  name_everyone: 'name_everyone',
  main_person: 'main_person',
  causing_the_problem: 'causing_the_problem',
  subject: 'subject',
  provide_whatever_info: 'provide_whatever_info',
  person_name: 'person_name',
  person_type: 'person_type',
  name: 'name',
  employer: 'employer',
  work_location: 'work_location',
  email: 'email',
  address: 'address',
  city: 'city',
  state: 'state',
  zip: 'zip',
  relationship_to_company: 'relationship_to_company',
  other: 'other',
  employee: 'employee',
  please_describe: 'please_describe',
  physical_description: 'physical_description',
  yes: 'yes',
  no: 'no',
  vehicle_information: 'vehicle_information',
  year: 'year',
  make: 'make',
  model: 'model',
  color: 'color',
  license_tag: 'license_tag',
  help: 'help',
  written: 'written',
  oral: 'oral',
  introduction: 'introduction',
  personal_identification: 'personal_identification',
  questions: 'questions',
  please_select_one: 'please_select_one',
  please_select_all_apply: 'please_select_all_apply',
  intro_text_1: 'intro_text_1',
  intro_text_2: 'intro_text_2',
  intro_text_3: 'intro_text_3',
  thanks_reporting: 'thanks_reporting',
  your_unique_code: 'your_unique_code',
  write_report_id: 'write_report_id',
  remember_emergency: 'remember_emergency',
  receive_email_question: 'receive_email_question',
  SUBMIT: 'SUBMIT',
  life_ring: 'life_ring',
  welcome: 'welcome',
  here_to_help: 'here_to_help',
  file_new_report: 'file_new_report',
  file_report: 'file_report',
  add_to_existing: 'add_to_existing',
  review_case_status: 'review_case_status',
  status_updates: 'status_updates',
  no_data_found: 'no_data_found',
  add_new_information: 'add_new_information',
  file_to_upload: 'file_to_upload',
  or_drag_here: 'or_drag_here',
  preview: 'preview',
  file_name: 'file_name',
  edit_file: 'edit_file',
  image: 'image',
  replace: 'replace',
  delete: 'delete',
  no_record_found: 'no_record_found',
  enter_unique_report: 'enter_unique_report',
  report_id: 'report_id',
  update_report: 'update_report',
  thanks_for_update: 'thanks_for_update',
  description: 'description',
  new_report: 'new_report',
  i_would_like_a: 'i_would_like_a',
  landingpage_selectdomain: 'landingpage_selectdomain',
  title: 'title',
  relationship_to_sender: 'relationship_to_sender',
  number_of_communications: 'number_of_communications'
};

export default langKey;
